import React from "react";
import { Button } from "@mui/material";
import { DataCardShell } from "../../../../../components/responsive";
import type { LifecycleRetreat } from "../../../../../types/retreatLifecycle";
import {
  formatLanguage,
  formatRetreatDateRange,
  statusChip,
} from "../../lifecycle/lifecycleUi";
import { retreatDisplayTitle, retreatLocationLine } from "../manageRetreatTypes";
import { SectionActionButtons } from "../SectionActionButtons";
import { dashboardContainedButtonSx } from "../dashboardUi";

export function ClosedRetreatCard({
  r,
  isSuperAdmin,
  onHistory,
  onDelete,
  onApprove,
  onRestore,
}: {
  r: LifecycleRetreat;
  isSuperAdmin: boolean;
  onHistory: (r: LifecycleRetreat) => void;
  onDelete: (r: LifecycleRetreat) => void;
  onApprove: (r: LifecycleRetreat) => void;
  onRestore: (r: LifecycleRetreat) => void;
}) {
  return (
    <DataCardShell
      title={retreatDisplayTitle(r)}
      subtitle={retreatLocationLine(r) || undefined}
      chips={statusChip("Closed")}
      fields={[
        { label: "Retreat Id", value: String(r.id ?? "—") },
        { label: "Language", value: formatLanguage(r.language) },
        {
          label: "Dates",
          value: formatRetreatDateRange(r.dateFrom, r.dateTo),
        },
      ]}
      primaryAction={
        <Button
          size="small"
          variant="contained"
          href={`/retreat-setup/${r.id}`}
          sx={dashboardContainedButtonSx}
        >
          View Retreat
        </Button>
      }
      secondaryActions={
        <SectionActionButtons
          r={r}
          kind="completed"
          isSuperAdmin={isSuperAdmin}
          onHistory={onHistory}
          onDelete={onDelete}
          onApprove={onApprove}
          onRestore={onRestore}
        />
      }
    />
  );
}
